var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.885,
    height: 50.86,
    viewBox: "0 0 68.885 50.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.885 76.765) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,49.215H16.708c-.286,12.177-3.739,13.559-8.077,13.953l-1.673.207V76.765l1.928-.1c5.664-.319,11.927-1.34,16.1-6.5,3.662-4.521,5.277-11.908,5.277-23.247V25.905H0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M111,25.905v23.31h16.485c-.286,12.177-3.628,13.559-7.965,13.953l-1.561.207V76.765l1.817-.1c5.664-.319,11.983-1.34,16.161-6.5,3.662-4.521,5.332-11.908,5.332-23.247V25.905Z",
    transform: "translate(-72.383 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowimg);
export default __webpack_public_path__ + "static/media/arrowimg.8853bf71abbaec11fdd9f34f4b448cda.svg";
export { ForwardRef as ReactComponent };